import { BZG_MODAL_DATA, BzgModalRef } from 'bz-genome-angular';
import { Component, Inject, OnChanges, SimpleChanges } from '@angular/core';
import { I18nService } from 'i18n/i18n.service';


@Component({
  selector: 'modal-confirmation',
  styleUrls: ['modal-confirmation.component.scss'],
  templateUrl: './modal-confirmation.component.html'
})
export class ModalConfirmationComponent implements OnChanges {
  typeButton: string = 'success';
  colorHeader: string = 'neutral';

  constructor(
    public modalComponentRef: BzgModalRef,
    @Inject(BZG_MODAL_DATA) public data: { 
      titleModal: string, 
      messageModal: string, 
      messageButtonConfirmation?: string, 
      typeButton?: string, 
      colorHeader?: string,
      messageButtonCancel?: string
    }) 
  { }

  ngOnChanges(changes: SimpleChanges): void {
    if (this.data.typeButton) {
      this.typeButton = this.data.typeButton;
    }
  }

  close() {
    this.modalComponentRef.close();
  }
  
  confirm() {
    this.modalComponentRef.close('confirm');
  }

  getColorButton() {
    return `bmc-confirm-confirmation__btn-${this.typeButton}`;
  }

  getColorHeader() {
    return `bmc-confirm-confirmation__header-${this.colorHeader}`;
  }
}
